"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueFilterForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactPanel = _interopRequireDefault(require("@adsk/alloy-react-panel"));
var _sdk = require("../../sdk");
var _FieldWrapper = require("../input-field-components/FieldWrapper");
var _TypeCategoryDropdown = require("../input-field-components/TypeCategoryDropdown");
var _TypeDropdown = require("../input-field-components/TypeDropdown");
var _StatusDropdown = require("../input-field-components/StatusDropdown");
var _UserMultiSelectDropdown = require("../input-field-components/UserMultiSelectDropdown");
var _RootCauseDropdown = require("../input-field-components/RootCauseDropdown");
var _DateField = require("../input-field-components/DateField");
var _CustomAttributeFilters = require("../input-field-components/CustomAttributeFilters");
var _ProjectMemberDropdown = require("../input-field-components/ProjectMemberDropdown");
var _common = require("../input-field-components/ProjectMemberDropdown/common");
var _PublishedFilterDropdown = require("./PublishedFilterDropdown");
var _ConditionalTooltip = require("../utils/components/ConditionalTooltip");
var _useHydratedRef = require("../utils/hooks/useHydratedRef");
var _hooks = require("../state/redux/hooks");
var _currentUserPermissions = require("../state/redux/ducks/currentUserPermissions");
var _useTranslations = require("../utils/i18n/useTranslations");
var _IssuesConsumer = require("../IssuesConsumer");
var _LocationFilterField = require("./LocationFilterField");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const castFilterArray = value => {
  return Array.isArray(value) ? value : (0, _lodash.isNil)(value) ? [] : [value];
};
const IssueFilterForm = exports.IssueFilterForm = (0, _IssuesConsumer.withIssuesConsumer)(_ref => {
  let {
    filters: filterBy,
    handleFilterChange,
    style,
    filtersToDisplay = ["issueTypeId", "issueTypeCategoryId", "status", "assignedTo", "watchers", "startDate", "dueDate", "locationId", "rootCauseId", "createdBy", "createdAt", "customAttributes", "published"],
    fixedTypeId,
    container
  } = _ref;
  const ref = (0, _useHydratedRef.useHydratedRef)();
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const dropdownsContainer = container ? container : ref.current;
  const levelOneUserShouldIncludeMemberFn = (0, _common.useGetLevelOneUserShouldIncludeMemberFn)();
  const permittedActions = (0, _hooks.useSelector)(_currentUserPermissions.getCurrentUserPermittedActionsForNewIssue);
  return /*#__PURE__*/_react.default.createElement(_alloyReactPanel.default.Body, {
    ref: ref,
    style: {
      height: "100%",
      paddingTop: 0,
      ...style
    }
  }, filtersToDisplay.includes("issueTypeCategoryId") && !fixedTypeId && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.issueTypeCategory")
  }, /*#__PURE__*/_react.default.createElement(_ConditionalTooltip.ConditionalTooltip
  // when type is being filtered, category filtering should be disabled
  , {
    condition: !!castFilterArray(filterBy.issueTypeId).length,
    content: T.translate("filterPanel.clearTypeToUseCategory")
  }, /*#__PURE__*/_react.default.createElement(_TypeCategoryDropdown.TypeCategoryMultiSelectDropdown, {
    disabled: !!castFilterArray(filterBy.issueTypeId).length,
    selectedCategoryIds: castFilterArray(filterBy.issueTypeCategoryId),
    onChange: selectedCategoryIds => {
      handleFilterChange({
        issueTypeCategoryId: selectedCategoryIds
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__issueTypeCategoryId"
  }))), filtersToDisplay.includes("issueTypeId") && !fixedTypeId && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.issueType")
  }, /*#__PURE__*/_react.default.createElement(_ConditionalTooltip.ConditionalTooltip
  // when category is being filtered, type filtering should be disabled
  , {
    condition: !!castFilterArray(filterBy.issueTypeCategoryId).length,
    content: T.translate("filterPanel.clearCategoryToUseType")
  }, /*#__PURE__*/_react.default.createElement(_TypeDropdown.TypeMultiSelectDropdown, {
    disabled: !!castFilterArray(filterBy.issueTypeCategoryId).length,
    selectedTypeIds: castFilterArray(filterBy.issueTypeId),
    onChange: selectedTypeIds => {
      handleFilterChange({
        issueTypeId: selectedTypeIds
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__issueTypeId"
  }))), fixedTypeId && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.issueType")
  }, /*#__PURE__*/_react.default.createElement(_ConditionalTooltip.ConditionalTooltip
  // if we're rendering here then the condition is always true,
  // but ConditionalTooltip has the styling we want and is cleaner
  // than separately importing a Tooltip and styling it.
  , {
    condition: !!fixedTypeId,
    content: T.translate("issueCreation.disabledReason.fixedType")
  }, /*#__PURE__*/_react.default.createElement(_TypeDropdown.TypeMultiSelectDropdown, {
    disabled: true,
    selectedTypeIds: [fixedTypeId],
    onChange: () => {},
    container: dropdownsContainer,
    "data-testid": "Filter__issueTypeId"
  }))), filtersToDisplay.includes("status") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.status")
  }, /*#__PURE__*/_react.default.createElement(_StatusDropdown.StatusMultiSelectDropdown, {
    selectedStatuses: castFilterArray(filterBy.status),
    onChange: selectedStatuses => {
      handleFilterChange({
        status: selectedStatuses
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__status"
  })), filtersToDisplay.includes("locationId") && /*#__PURE__*/_react.default.createElement(_LocationFilterField.LocationFilterField, {
    filters: filterBy,
    handleFilterChange: handleFilterChange,
    container: dropdownsContainer
  }), filtersToDisplay.includes("assignedTo") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.assignedTo")
  }, /*#__PURE__*/_react.default.createElement(_ProjectMemberDropdown.ProjectMemberMultiSelectFilterDropdown, {
    shouldIncludeUnassigned: true,
    shouldIncludeMemberFn: !permittedActions.includes(_sdk.PermittedAction.AssignAll) ? levelOneUserShouldIncludeMemberFn : undefined,
    selectedOxygenIds: castFilterArray(filterBy.assignedTo),
    onChange: selectedOxygenIds => {
      handleFilterChange({
        assignedTo: selectedOxygenIds
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__assignedTo"
  })), filtersToDisplay.includes("watchers") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: /*#__PURE__*/_react.default.createElement(_ProjectMemberDropdown.WatcherFieldLabel, null)
  }, /*#__PURE__*/_react.default.createElement(_UserMultiSelectDropdown.UserMultiSelectDropdown, {
    placeholder: T.translate("issueCreation.watchers.placeholder"),
    shouldIncludeMemberFn: !permittedActions.includes(_sdk.PermittedAction.AssignAll) ? levelOneUserShouldIncludeMemberFn : undefined,
    selectedOxygenIds: castFilterArray(filterBy.watchers),
    onChange: selectedOxygenIds => {
      handleFilterChange({
        watchers: selectedOxygenIds
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__watchers"
  })), filtersToDisplay.includes("startDate") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.startDate")
  }, /*#__PURE__*/_react.default.createElement(_DateField.DateRangeField, {
    type: _DateField.DateType.Start,
    range: filterBy.startDate,
    onChange: range => {
      handleFilterChange({
        startDate: range
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__startDate"
  })), filtersToDisplay.includes("dueDate") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.dueDate")
  }, /*#__PURE__*/_react.default.createElement(_DateField.DateRangeField, {
    type: _DateField.DateType.Due,
    range: filterBy.dueDate,
    onChange: range => {
      handleFilterChange({
        dueDate: range
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__dueDate"
  })), filtersToDisplay.includes("rootCauseId") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.rootCause")
  }, /*#__PURE__*/_react.default.createElement(_RootCauseDropdown.RootCauseMultiSelectDropdown, {
    selectedRootCauseIds: castFilterArray(filterBy.rootCauseId),
    onChange: selectedRootCauseIds => {
      handleFilterChange({
        rootCauseId: selectedRootCauseIds
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__rootCauseId"
  })), filtersToDisplay.includes("published") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("filterPanel.filters.published")
  }, /*#__PURE__*/_react.default.createElement(_PublishedFilterDropdown.PublishedFilterDropdown, {
    selectedFilter: filterBy.published,
    onChange: option => {
      handleFilterChange({
        published:
        // server expects undefined as value indicating "both"
        typeof option.value === "boolean" ? option.value : undefined
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__published"
  })), filtersToDisplay.includes("createdBy") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.createdBy")
  }, /*#__PURE__*/_react.default.createElement(_UserMultiSelectDropdown.UserMultiSelectDropdown, {
    selectedOxygenIds: castFilterArray(filterBy.createdBy),
    onChange: selectedOxygenIds => {
      handleFilterChange({
        createdBy: selectedOxygenIds
      });
    },
    container: dropdownsContainer,
    placeholder: T.translate("filterPanel.createdByPlaceholder"),
    "data-testid": "Filter__createdBy"
  })), filtersToDisplay.includes("createdAt") && /*#__PURE__*/_react.default.createElement(_FieldWrapper.FieldWrapper, {
    label: T.translate("issueAttributes.createdAt")
  }, /*#__PURE__*/_react.default.createElement(_DateField.DateRangeField, {
    type: _DateField.DateType.Past,
    range: filterBy.createdAt,
    onChange: range => {
      handleFilterChange({
        createdAt: range
      });
    },
    container: dropdownsContainer,
    "data-testid": "Filter__createdAt"
  })), filtersToDisplay.includes("customAttributes") && /*#__PURE__*/_react.default.createElement(_CustomAttributeFilters.CustomAttributeFilters, {
    filter: filterBy.customAttributes,
    handleFilterChange: handleFilterChange,
    container: dropdownsContainer,
    "data-testid": "Filter__customAttributes"
  }));
});
//# sourceMappingURL=IssueFilterForm.js.map